import {Box, SxProps, Theme, Typography} from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
import React from "react";
import styles from "./borderedSection.module.scss";

export interface BorderedSectionProps {
    icon?: React.ElementType;
    title?: string;
    marginTop?: string | number;
    color?: string;
    titleRearView?: React.ReactNode;
    sx?: SxProps<Theme>;
    showBox?: boolean;
    children: React.ReactNode;
}

export function BorderedSection({
                                    icon,
                                    title,
                                    titleRearView,
                                    marginTop,
                                    sx,
                                    showBox = true,
                                    children,
                                }: BorderedSectionProps) {

    return (
        <Box sx={{ marginTop }}>
            <Box display="flex" justifyContent="space-between">
                <Box className={styles.label}>
                    {icon && <SvgIcon component={icon} fontSize="small" />}
                    {title && (
                        <Typography variant="body2" className={styles.labelText}>
                            {title}
                        </Typography>
                    )}
                </Box>
                {titleRearView}
            </Box>

            {showBox && (
                <Box className={styles.container}
                     display="flex"
                     flexDirection="column"
                     justifyContent="center"
                     sx={sx}
                >
                    {children}
                </Box>
            )}

            {!showBox && children}

        </Box>
    );
}

export default BorderedSection;
